namespace RioERP.Enquiry {
    export interface PendingOrderProductsForm {
        PendingOrderId: Serenity.IntegerEditor;
        ProductId: Serenity.LookupEditor;
        Name: Serenity.StringEditor;
        Sku: Serenity.StringEditor;
    }

    export class PendingOrderProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Enquiry.PendingOrderProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PendingOrderProductsForm.init)  {
                PendingOrderProductsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;

                Q.initFormType(PendingOrderProductsForm, [
                    'PendingOrderId', w0,
                    'ProductId', w1,
                    'Name', w2,
                    'Sku', w2
                ]);
            }
        }
    }
}
